<template>
  <div class="service-unavailable">
    <div class="service-unavailable__container">
      <img
        class="service-unavailable__logo"
        src="@/assets/images/brand/logo_login.svg"
        alt="Early Stage"
      />
      <div class="service-unavailable__wrapper">
        <div class="service-unavailable__content">
          <h2>Trwają prace systemowe</h2>
          <p>Uprzejmie informujemy, że <b>Early Stage Online</b> jest tymczasowo niedostępny ze względu na prace serwisowe.</p>
          <p>Przepraszamy za niedogodności!</p>
          <img
            class="service-unavailable__bubbles"
            src="@/assets/images/unavailable/bubbles.svg"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ServiceUnavailable',
};
</script>
<style lang="scss" scoped>
.service-unavailable {
  @apply bg-blue-light-main;
  &__container {
    @apply relative flex flex-col items-center mx-auto my-0 text-center;
    min-height: 100vh;
  }
  &__logo {
    @apply h-auto block mx-auto mt-16;
    max-width: 200px;
    @media screen and (min-width: 768px) {
      @apply mt-24;
      max-width: 300px;
    }
  }
  &__wrapper {
    @apply flex flex-col w-full justify-between;
    height: 100%;
    flex: 1;
  }
  &__content {
    @apply px-4;
    h2 {
      @apply text-xl font-bold mt-12 mb-6;
      @media screen and (min-width: 768px) {
        @apply text-2xl mt-24;
      }
    }
    p {
      @apply text-base leading-normal;
      @media screen and (min-width: 768px) {
        @apply text-lg;
      }
    }
  }
  &__bubbles {
    @apply mt-6;
    @media screen and (min-width: 768px) {
      @apply mt-12;
    }
  }
}
</style>
